import { IFootNote } from '@seb/web-design-system/core';

export function toFootnote(cmp: { wrapperFootnote?: string; disclaimer?: string; uid?: string }): IFootNote[] {
  if (cmp?.disclaimer) {
    return [{ note: cmp.disclaimer, id: cmp.uid }];
  } else if (cmp?.wrapperFootnote) {
    return [{ note: cmp.wrapperFootnote, id: cmp.uid }];
  }
  return [];
}
